import React from "react";
import ResultBox from "../shared/ResultBox";
import StampBadge from "../shared/StampBadge";
import { fmt } from "../utils/format";

export default function GenericStampResult({ result, toDisplay, unitLabel }) {
  return (
    <>
      <div
        className="flex items-center justify-between rounded-xl px-5 py-4 bg-neutral-900"
      >
        <div>
          <div className="text-xs mb-1 text-neutral-400">
            جمع کل حق‌الوکاله
          </div>
          <div className="text-lg font-bold text-neutral-200" >
            {fmt(toDisplay(result.total))} {unitLabel}
          </div>
        </div>
        <StampBadge
          amount={`${fmt(
            toDisplay(
              result.breakdownFirst
                ? result.breakdownFirst.total
                : result.stampTax
            )
          )} ${unitLabel}`}
        />
      </div>

      {result.breakdownFirst && (
        <div className="grid sm:grid-cols-2 gap-4">
          <ResultBox
            label={`سهم ${result.breakdownFirst.fundLabel}`}
            value={`${fmt(toDisplay(result.breakdownFirst.fundShare))} ${unitLabel}${
              result.breakdownFirst.barShare
                ? ` + ${fmt(
                    toDisplay(result.breakdownFirst.barShare)
                  )} ${unitLabel} سهم کانون`
                : ""
            }`}
          />
        </div>
      )}
    </>
  );
}
